import { FC } from "react";
import CustomPopup from "../../../../custom-components/CustomPopup";
import { FormikProps } from "formik";
import { UserResetPasswordFirstStep } from "../../../../domain/models/dto/UserDTO";
import CustomInput from "../../../../custom-components/form-inputs/CustomInput";
import { useTranslation } from "react-i18next";
import CustomError from "../../../../custom-components/form-inputs/CustomError";
import { userResetPasswordFirstStepFields } from "../../../../validation-schemas/user-schemas/UserResetPasswordSchema";

interface ResetPasswordFirstStepProps {
    firstStepForm: FormikProps<UserResetPasswordFirstStep>;
    error: string;
    isVisible: boolean;
    setIsVisible: (value: boolean) => void;
}

const ResetPasswordFirstStep: FC<ResetPasswordFirstStepProps> = (props) => {
    const { t } = useTranslation();

    return (
        <CustomPopup
            isVisible={props.isVisible}
            setIsVisible={props.setIsVisible}
            wrapClassName="dmin2:min-w-[1062px] di6:min-w-[800px] ti6:min-w-[650px] ti7:min-w-[362px] tmax4:min-w-[362px]"
            title={t("resetPassword.resettingProcedure")}
            titleClassName="my-8 dmax2:my-6"
            confirmTitle={t("resetPassword.receiveCode")}
            confirmHandler={props.firstStepForm.handleSubmit}
            confirmButtonClassName="w-[193px] dmax2:w-[133px] h-[50px] dmax2:h-[40px] mt-8 dmax2:mt-6"
            buttonElement={
                <div className="flex justify-end mb-8 dmax2:mb-6">
                    <span
                        onClick={() => props.setIsVisible(true)}
                        className="H20 dmax2:H16 hover:H20B dmax2:hover:H16B text-textWhite cursor-pointer transition-all duration-300"
                    >
                        {t("login.forgotPassword")}
                    </span>
                </div>
            }
        >
            <div className="relative flex flex-col items-center justify-center w-[410px] dmax2:w-[330px]">
                <p className="H20 dmax2:H16 text-textFaded text-center mb-6 dmax2:mb-5">
                    {t("resetPassword.resetFirstStepRule")}
                </p>
                <CustomInput
                    form={props.firstStepForm}
                    name="email"
                    fields={userResetPasswordFirstStepFields}
                    className="w-full h-[63px] dmax2:h-[45px] mb-3 dmax2:mb-2"
                />
                <CustomError form={props.firstStepForm} errorKey={props.error} className="text-center" />
            </div>
        </CustomPopup>
    );
};

export default ResetPasswordFirstStep;
